import { Box } from '@mui/material';
import { FunctionComponent, useContext } from 'react';
import { ViewHeader } from '../../../../core/components/ViewHeader/ViewHeader';
import { AppContext } from '../../../../core/config';
import { useAppTranslate, useBusinessContext } from '../../../../core/hooks';
import { Loader } from '../../../../ui/components';
import { useChartSettings } from '../../../chart-settings/hooks';
import { CpeStatisticsBusinessContextConfig } from '../../config';
import { useMonitoredDevicesApiGet } from '../../hooks';
import { CpeStatisticsTable } from '../CpeStatisticsTable/CpeStatisticsTable';

export const MonitoredDevices: FunctionComponent = () => {
  const chartSettingsInteraction = useChartSettings();
  const {customerId} = useContext(AppContext);
  const { data, isFetching, isFetched } = useMonitoredDevicesApiGet(customerId, chartSettingsInteraction.chartSettings);
  const translate = useAppTranslate();
  useBusinessContext(CpeStatisticsBusinessContextConfig);

  return <Box sx={{ p: 2 }}>
    <ViewHeader title={translate('title')} />
    {isFetching
      ? <Loader loading={isFetching} />
      : (isFetched && data && (
        <CpeStatisticsTable
          monitoredDevices={data}
          customerId={customerId}
          chartSettingsInteraction={chartSettingsInteraction}
        />
      ))
    }
  </Box>;
};
